export const LoaderType = {
  dots: "dots",
  eclipse: "eclipse",
  progressBar: "progress-bar",
  spinner: "spinner"
}

type LoaderProps = {
  type?: string,
  display?: boolean
}

const eclipseLoader = () => {
  return (
    <div className="loader-holder">
      <div className="eclipse-loader">
        <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
          <path
            d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
            fill="#0095da"
            stroke="none"
          ></path>
        </svg>
      </div>
    </div>
  );
}

const dotsLoader = () => {
  return (
    <div className="location-results-panel active">
      <div className="loading-dots location-item">
        <div className="loading-dots--dot"></div>
        <div className="loading-dots--dot"></div>
        <div className="loading-dots--dot"></div>
      </div>
    </div>
  );
}

const progressBarLoader = () => {
  return (
    <div className="loader-holder">
      <div className="progress-loader">
        <div></div>
      </div>
    </div>
  );
}

const spinnerLoader = () => {
  return (
    <div className="loader-holder">
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export const Loader = (props: LoaderProps) => {
  const { type = LoaderType.eclipse, display = true } = props;

  if (!display) {
    return null;
  }

  switch (type) {
    case LoaderType.dots:
      return dotsLoader();

    case LoaderType.eclipse:
      return eclipseLoader();

    case LoaderType.progressBar:
      return progressBarLoader();

    case LoaderType.spinner:
      return spinnerLoader();

    default:
      return eclipseLoader();
  }
}

export default Loader;
